export default {
  data() {
    return {
      fallbackImageUrl: require('@/static/img/product-alternate-image.png')
    };
  },
  methods: {
    getImageUrl(url) {
      return url || this.fallbackImageUrl;
    },
    handleImageError(event) {
      event.target.src = this.fallbackImageUrl;
    }
  }
};
